import { statusClasses, statusDot, type TopicStatus } from "@/utils/topicStyles";

type Props = {
  status: TopicStatus;
  size?: "sm" | "md";
};

export default function StatusBadge({ status, size = "sm" }: Props) {
  const pad = size === "sm" ? "px-2.5 py-1 text-xs" : "px-3 py-1.5 text-sm";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-md border font-label font-medium whitespace-nowrap ${pad} ${statusClasses(status)}`}
    >
      <span className={`inline-block h-1.5 w-1.5 rounded-full ${statusDot(status)}`} />
      {status}
    </span>
  );
}